// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"79cbfb0e","121":"7a50cb32","686":"8838e75f","794":"0aff3b48"}[chunkId] + ".chunk.js";
};